import * as styles from './photoGallery.styles';

type ImageCounterProps = {
  currentIndex: number;
  totalCount: number;
  onClick: () => void;
};

const GalleryIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M9.28418 0C9.94167 0.000216604 10.4766 0.544467 10.4766 1.21289V2.00586L13.1816 2.88574C13.8081 3.09037 14.1475 3.79884 13.9375 4.46387L11.2139 13.1074C11.1141 13.4258 10.903 13.6888 10.6211 13.8467C10.4398 13.9481 10.2438 14 10.0469 14C9.92989 14 9.81165 13.9813 9.69727 13.9443L2.07715 11.4629H1.19336C0.535773 11.4629 0.000142886 10.9184 0 10.25V1.21289C0 0.544334 0.535685 0 1.19336 0H9.28418ZM10.4766 3.61133L12.2705 4.19434C12.4414 4.24994 12.536 4.43672 12.4805 4.61133L10.5098 10.8623C10.4655 11.0034 10.3381 11.0927 10.2002 11.0928C10.182 11.0928 10.1637 11.0875 10.1455 11.084C9.92781 11.3159 9.62329 11.4628 9.28418 11.4629H4.21191L9.89648 13.3135C10.0292 13.3576 10.1747 13.3417 10.3057 13.2676C10.4428 13.1908 10.5443 13.0632 10.5938 12.9062L13.3184 4.26172C13.4181 3.94423 13.268 3.6092 12.9834 3.5166L10.4766 2.70117V3.61133ZM1.19336 0.661133C0.89489 0.661133 0.650391 0.9086 0.650391 1.21289V10.25C0.650534 10.5542 0.894978 10.8008 1.19336 10.8008H2.03027C2.0719 10.792 2.11387 10.792 2.15723 10.8008H9.28418C9.58323 10.8005 9.82603 10.554 9.82617 10.25V1.21289C9.82617 0.908746 9.58332 0.661369 9.28418 0.661133H1.19336ZM10.4766 8.80078L11.7617 4.72363L10.4766 4.30566V8.80078Z"
      fill="white"
    />
    <path
      d="M8.80811 1.44031C8.98753 1.44053 9.1333 1.58892 9.1333 1.77136V8.1991C9.13329 8.38153 8.98752 8.52993 8.80811 8.53015H1.66943C1.48991 8.53006 1.34425 8.38161 1.34424 8.1991V1.77136C1.34424 1.58885 1.48991 1.4404 1.66943 1.44031H8.80811ZM1.99463 7.86804H8.48193V2.10144H1.99463V7.86804Z"
      fill="white"
    />
  </svg>
);

export const ImageCounter = ({ currentIndex, totalCount, onClick }: ImageCounterProps) => (
  <button
    className={styles.imageCounter}
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    aria-label={`Photo ${currentIndex + 1} of ${totalCount}, view all photos`}
  >
    <GalleryIcon />
    {currentIndex + 1} / {totalCount}
  </button>
);
